<template>
  <div class="donateList">
    <Scroller v-if="!empty" :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <div class="list">
        <ul>
          <li v-for="(item, index) of list" :key="index">
            <p>
            <span>
              <b>捐赠编号:</b>
              <b>{{item.no}}
                <img v-if="item.isoversea == 1"  src="../../assets/images/haiwai.png">
                <img v-if="item.issplit == 1"  src="../../assets/images/chai.png">
              </b>
            </span>
              <b>
                <!--<i>{{item.orderstatus_text}}</i>-->
                <!--<b v-if="item.orderstatus == 0 || item.orderstatus == 3 || item.orderstatus == 6" @click="deleteFn(item, index)">-->
                  <!--<img src="../../assets/images/delete1.png">-->
                <!--</b>-->
                <i>捐赠时间:{{item.pay_time}}</i>
              </b>
            </p>
            <div class="product" @click="detailsClick(item)">
              <div v-if="item && item.itemlist && item.itemlist.length <= 1 && item.itemlist.length > 0" class="productBox">
                <div class="img">
                  <img v-lazy="item.itemlist[0].img_path">
                  <img v-if="item.itemlist[0].isgift == 1" class="zeng" src="../../assets/images/zeng1.png">
                </div>
                <div class="proContent">
                  <!--<b>{{item.itemlist[0] && item.itemlist[0].name && item.itemlist[0].name.length > 26 ? item.itemlist[0].name.slice(0, 26) + '...' : item.itemlist[0].name}}</b>-->
                  <b>同舟共济、大爱无疆<br/>感谢你的爱心捐助!</b>
                  <p>
                    <!--<b>{{item.itemlist[0].spec}}</b>-->
                  </p>
                </div>
              </div>
              <div v-if="item.itemlist && item.itemlist.length  > 1" class="bestSellingSwiper" style="overflow: hidden;position:relative;">
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(itemSon, idx) of item.itemlist" :key="idx">
                    <div class="img">
                      <div class="tag" v-if="itemSon.ispresale == 1">
                        <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
                      </div>
                      <img v-lazy="itemSon.img_path">
                      <img v-if="itemSon.isgift == 1" class="zeng" src="../../assets/images/zeng1.png">
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <span class="totalPrice" :style="item && item.itemlist && item.itemlist.length  > 1 ? {} : {'position': 'absolute'}" :class="{'totalPriceNoShadow' : item.itemlist && item.itemlist.length  < 4, 'totalPriceShadow' : item.itemlist && item.itemlist.length >= 4}">
                <i style="font-size: 0.12rem;line-height: .11rem;font-style: normal;">捐赠金额:</i>
                <span class="price">
                {{String(parseFloat(item.ordermoney).toFixed(2)).slice(0, String(parseFloat(item.ordermoney).toFixed(2)).indexOf('.'))}}
                <i>
                 {{String(parseFloat(item.ordermoney).toFixed(2)).slice(String(parseFloat(item.ordermoney).toFixed(2)).indexOf('.'), String(parseFloat(item.ordermoney).toFixed(2)).length)}}
                </i>
              </span>
              <!--<b>共{{item.item_nums}}件</b>-->
            </span>
            </div>
            <div class="proFooter">
              <div class="p">
                <!--<p style="color: #000;margin-left: -.06rem;">同舟共济、大爱无疆，感谢您的爱心捐助。</p>-->
                <p :class="'countDown'+index" v-if="item.orderstatus == 1">剩<van-count-down @finish="finish(index)" :time="item.time" format="HH时mm分ss秒"/>关闭交易</p>
                <p :class="'countDown'+index" v-if="item.orderstatus == 2">修改地址剩余<van-count-down @finish="finish(index)" :time="item.time" format="mm 分 ss 秒"/></p>
              </div>
              <div class="proBtn">
                <button v-if="item.orderstatus == 1" class="grayBtn" @click="cancelFn(item)">取消订单</button>
                <button v-if="(item.orderstatus == 2 && item.status != 2) || item.orderstatus == 7" class="grayBtn" @click="checkTrans(item)">查看物流</button>
                <button v-if="(item.orderstatus == 3 || item.orderstatus == 6) && item.iscomment == 0 && item.is_act_order == 0" class="grayBtn" @click="detailsClick(item)">评价晒单</button><!--与app不一致-->
                <!--<button class="redBtn">再次购买</button>-->
                <!--<button v-if="(item.orderstatus == 4 || item.orderstatus == 5) && (item.status == 8 || item.status == 9)" class="grayBtn" @click="afterDetailsClick(item)">售后详情</button>&lt;!&ndash;与app不一致&ndash;&gt;-->
                <button v-if="item.orderstatus == 1" class="redBtn" @click="goBuy(item)">去支付</button>
                <button v-if="(item.orderstatus == 2 && item.status != 2) || item.orderstatus == 7" class="redBtn" @click="confirm(item, index)">确认收货</button>
                <button v-if="(item.orderstatus == 0 || item.orderstatus == 4 || item.orderstatus == 5) && item.is_act_order == 0" class="redBtn" @click="buyAgain(item, 'order')">重新购买</button>
                <button v-if="(item.orderstatus == 3 || item.orderstatus == 6) && item.is_act_order == 0" class="redBtn" @click="buyAgain(item, 'order')">再次购买</button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Scroller>
    <div class="empty" v-if="productlist && productlist.length > 0 && empty" ref="empty" style="padding-top: 0.39rem;margin-top: 0.98rem;">
      <img src="../../assets/images/emptyorder.png">
      <p>啊哦～您还没有相关订单</p>
    </div>
    <div ref="recommend" style="margin-top: 0.1rem;padding: 0 0.1rem;background: #fff;" v-if="productlist && productlist.length > 0 && recommend" >
      <product-list :title="title" :productlist="productlist"></product-list>
    </div>
    <div class="empty emptyNoProduct" ref="empty" v-if="productlist && productlist.length <= 0 && empty">
      <empty :path="'noOrder'"></empty>
    </div>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png">
    </div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import productList from '../common/productList'
import empty from '../emptypage/empty'
import Vue from 'vue'
import Scroller from '../common/Scroller'
import { Sticky, Tag } from 'vant'

Vue.use(Sticky)
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'donateList',
  data () {
    return {
      // ceil: false,
      empty: false,
      recommend: false,
      oldtop: null,
      now: null,
      timer: null,
      nav: ['全部', '待付款', '待收货', '待评价', '售后'],
      navClick: 0,
      title: '精选好物',
      list: [],
      // img: ['http://devstaticfile.oss-cn-shanghai.aliyuncs.com/Uploads/files/20190827/o_1dj8efrl6ft2171ts617t28jhc.png', 'http://devstaticfile.oss-cn-shanghai.aliyuncs.com/Uploads/goods/201812/o_1cs4c0obd16om1hso89i140u1jkgc.jpg'],
      // list: [],
      productlist: [],
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  components: {
    productList,
    empty,
    Scroller,
    [Tag.name]: Tag
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'donate'})
    }
    // this.navClick = this.$store.state.orderlistNavid
    // this.nowPage = 1
    // this.list = []
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        // vm.navClick = vm.$store.state.orderlistNavid
        vm.productlist = []
        vm.nowPage = 0
      })
    } else {
      next(vm => {
        if (from.path == '/percen') {
          vm.empty = false
          vm.recommend = false
          vm.productlist = []
          vm.nowPage = 0
        }
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path == '/percen') this.loading = true
    next()
  },
  methods: {
    getData: function () {
      var url, oid
      oid = this.$route.query.orderid ? this.$route.query.orderid : ''
      if (oid) {
        url = this.$ajax.getJzOrderList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&oid=' + oid
      } else {
        url = this.$ajax.getJzOrderList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      }

      // var url = this.$ajax.getJzOrderList_URL
      // if (this.navClick == 0) {
      //   url = this.$ajax.getOrderList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&status=' + 99
      // } else if (this.navClick != 4) {
      //   url = this.$ajax.getOrderList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&status=' + this.navClick
      // } else {
      //   afterUrl = this.$ajax.getRefundOrderList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      // }
      var that = this
      that.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          var nowTime = new Date().getTime()
          var futureTime = null
          if (that.nowPage == 1) {
            res.data.orderlist.map(item => {
              if (item.orderstatus == 2) { // 待发货
                // if ((item.pay_time != '' && item.pay_time != undefined) && (item.close_time != '' && item.close_time != undefined)) {
                //   futureTime = that.parserDate(item.pay_time).getTime() + parseInt(item.close_time) * 1000 * 60
                //   item.time = futureTime - nowTime
                // }
                if (item.pay_time != '' && item.pay_time != undefined) {
                  futureTime = that.parserDate(item.pay_time).getTime() + 1000 * 60 * 30
                  item.time = futureTime - nowTime
                }
              } else if (item.orderstatus == 1) { // 待付款
                if (item.order_time != '' && item.order_time != undefined) {
                  futureTime = that.parserDate(item.order_time).getTime() + parseInt(item.close_time) * 1000 * 60
                  item.time = futureTime - nowTime
                }
              }
            })
            that.list = res.data.orderlist
            that.refresh = false
          } else {
            res.data.orderlist.map(item => {
              if (item.orderstatus == 2) { // 待发货
                // if ((item.pay_time != '' && item.pay_time != undefined) && (item.close_time != '' && item.close_time != undefined)) {
                //   futureTime = that.parserDate(item.pay_time).getTime() + parseInt(item.close_time) * 1000 * 60
                //   item.time = futureTime - nowTime
                // }
                if (item.pay_time != '' && item.pay_time != undefined) {
                  futureTime = that.parserDate(item.pay_time).getTime() + 1000 * 60 * 30
                  item.time = futureTime - nowTime
                }
              } else if (item.orderstatus == 1) { // 待付款
                if (item.order_time != '' && item.order_time != undefined) {
                  futureTime = that.parserDate(item.order_time).getTime() + 30 * 60 * 1000
                  item.time = futureTime - nowTime
                }
              }
            })
            that.list = that.list.concat(res.data.orderlist)
          }
          if (that.list.length <= 0) {
                that.loading = false
                that.finished = true
                that.empty = true
                that.recommend = true
            // that.$customRequestAjax(recommendUrl).then(res => {
            //   if (res.data.code === 200) {
            //     that.productlist = res.data.itemlist
            //     that.loading = false
            //     that.finished = true
            //     that.empty = true
            //     that.recommend = true
            //     console.log(1, that.empty, that.recommend)
            //   }
            // })
            // setTimeout(function () {
            //   that.$refs.empty.style.display = 'block'
            //   that.$refs.recommend.style.display = 'block'
            // })
          } else {
            that.loading = false
            that.empty = false
            that.recommend = false
            if (res.data.orderlist.length < that.pagesize) {
              that.finished = true
            } else {
              that.finished = false
            }
          }
          // console.log(2, that.empty, that.recommend)
        }
      })
    },
    onRefresh () {
      this.refresh = true
      // this.finished = false
      this.nowPage = 1
      // this.list = []
      var that = this
      that.getData()
      // this.editorClick()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 500)
    },
    // evaluate: function () {
    //   console.log(items)
    // },
    goBuy: function (items) {
      if (items.is_coupon == 1) {
        window.location.href = './static/wx/html/20190820/buyCoupon/pay.html?orderId=' + items.id + '&m=' + items.ordermoney
      } else {
        this.$router.push({
          path: '/pay',
          query: {
            id: items.id,
            money: items.ordermoney
          }
        })
      }
    },
    finish: function (id) {
      $('.countDown' + id).css('display', 'none')
    },
    parserDate: function (date) {
      var t = Date.parse(date.replace(/-/g, '/'))
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, '/')))
      } else {
        return new Date()
      }
    },
    deleteFn: function (items, id) {
      var url = this.$ajax.deleteOrder_URL
      var data = {
        id: items.id
      }
      var that = this
      this.$dialog.confirm({
        message: '确认删除订单？',
        className: 'collect_button_alert',
        cancelButtonColor: '#FC0324',
        confirmButtonColor: '#FFFCFC',
        closeOnPopstate: true
      }).then(function () {
        that.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code === 200) {
            that.list.splice(id, 1)
          }
        })
      }).catch(function () {
        // on cancel
      })
    },
    cancelFn: function (items) {
      var url = this.$ajax.cancelOrder_URL
      var data = {
        id: items.id
      }
      var that = this
      this.$dialog.confirm({
        message: '确认取消订单？',
        className: 'collect_button_alert',
        cancelButtonColor: '#FC0324',
        confirmButtonColor: '#FFFCFC',
        closeOnPopstate: true
      }).then(function () {
        that.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code === 200) {
            that.nowPage = 1
            that.getData()
          }
        })
      }).catch(function () {
        // on cancel
      })
    },
    buyAgain: function (items, type) {
      var url = this.$ajax.addShoppingCart_URL
      var skuId = []
      var itemnum = []
      if (type == 'after') {
        items.item_list.map(item => {
          if (item.isgift == 0 && !item.isadditem && item.ischangebuy == 0){
            skuId.push(item.skuid)
            itemnum.push(item.num)
            liveId.push(item.liveid)
          }
        })
      } else if (type == 'order') {
        items.itemlist.map(item => {
          if (item.isgift == 0 && !item.isadditem && item.ischangebuy == 0){
            skuId.push(item.skuid)
            itemnum.push(item.num)
          }
        })
      }
      var data = {
        skuid: skuId.join(),
        itemnum: itemnum.join()
      }
      if (!data.skuid.length) {
        this.$router.push('/cart')
        return
      }
      var that = this
      this.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code === 200) {
          that.$store.commit('ADD_CART_INIT_DATA', 1)
          that.$router.push('/cart')
        }
      })
    },
    checkTrans: function (items) {
      if (items.issplit == 0) {
        this.$router.push({path: '/logistics',
          query: {
            id: items.id
          }
        })
      } else if (items.issplit == 1) {
        this.$router.push({path: '/splitdetails',
          query: {
            id: items.id
          }
        })
      }
    },
    navFn: function (id) {
      var that = this
      if (that.navClick != id) {
        that.empty = false
        that.recommend = false
        that.navClick = id
        that.$store.commit('ORDERLIST_NAVID', this.navClick)
        // that.ceil = false
        that.nowPage = 0
        that.list = []
        that.onInfinite()
      } else {
        if (that && that.$refs.my_scroller) { // 通过vm实例访问this
          sessionStorage.askPositon = ''
          setTimeout(function () {
            window.scrollTo(0, sessionStorage.askPositon, true)
          }, 0) // 同步转异步操作
        }
      }
    },
    confirm: function (items, id) {
      var url = this.$ajax.confirmOrderItem_URL
      var data = {
        id: items.id
      }
      var that = this
      that.$customRequestAjax.post(url, data).then(res => {
        if (res.data.code === 200) {
          that.nowPage = 1
          that.list = []
          that.getData()
        }
      })
    },
    homeClick: function () {
      this.$router.push('/')
    },
    // searchClick: function () {
    //   this.$router.push('/ordersearch')
    // },
    detailsClick: function (items) {
      // this.$router.push({path: '/orderdetails', query: {id: items.id}})

    },
    afterDetailsClick: function (items) {
      // if (items.order_type == 0) {
      //   this.$router.push({
      //     path: '/afterdetails',
      //     query: {
      //       id: items.id
      //     }
      //   })
      // } else {
      //   this.$router.push({
      //     path: '/orderdetails',
      //     query: {
      //       id: items.order_id
      //     }
      //   })
      // }
    }
  }
}
</script>

<style scoped lang="scss">
  .list ul li p, .product {
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -webkit-justify-content: space-between;
    -o-justify-content: space-between;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
  }
  .donateList {
    header {
      background: #fff;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      z-index: 100;
      transition: all .1s;
      /* &.ceiling {*/
      /*   top: -0.38rem;*/
      /*   z-index: 20;*/
      /*   background: #fff;*/
      /* }*/
      .searchBox {
        height: .44rem;
        background: #fff;
        padding: 0 .11rem;
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -moz-flex;
        align-items: center;
        -webkit-align-items: center;
        -o-align-items: center;
        -ms-align-items: center;
        -moz-align-items: center;
      }
      .search{
        flex: 1;
        -webkit-flex: 1;
        -o-flex: 1;
        -ms-flex: 1;
        -moz-flex: 1;
        /*width: 3.23rem;*/
        margin-right: 0.1rem;
        height: .27rem;
        line-height: .25rem;
        font-size: .13rem;
        background: #F7F7F7;
        border-radius: .15rem;
        color: #999999;
        position: relative;
        .searchicon {
          font-size: 0;
          position: absolute;
          width: .2rem;
          height: .2rem;
          left: .1rem;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          /*overflow: hidden;*/
          .van-icon-search {
            color: transparent;
            font-weight: 600;
            font-size: 0.2rem;
            height: 100%;
            background: url('../../assets/images/search3.png') no-repeat center;
            background-size: 100%;
          }
        }
        .inp {
          border: 0.01rem solid transparent;
          background: transparent;
          border-radius: 0.15rem;
          height: 0.27rem;
          line-height: 0.25rem;
          padding-left: 0.35rem;
          font-size: 0.13rem;
          color: #999999;
          -webkit-transition: all .35s;
          transition: all .35s;
          margin-right: 0.1rem;
        }
      }
      ul {
        height: 0.45rem;
        padding: 0.14rem 0.25rem 0.06rem;
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -webkit-flex;
        display: -o-flex;
        justify-content: space-between;
        -moz-justify-content: space-between;
        -ms-justify-content: space-between;
        -webkit-justify-content: space-between;
        -o-justify-content: space-between;
        li {
          color: #4B4B4B;
          font-size: 0.14rem;
          padding-bottom: 0.05rem;
          border-bottom: 0.02rem solid transparent;
          font-weight: 400;
          &.colorLis {
            font-weight: 600;
            position: relative;
            /*border-bottom: 0.02rem solid #FC0324;*/
          }
          &.colorLis:after {
            content: '';
            display: block;
            width: 0.265rem;
            height: 0.025rem;
            background:linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -webkit-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -moz-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -ms-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -o-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            position: absolute;
            bottom: -0.02rem;
            left: 50%;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            -o-transform: translateX(-50%);
            /*border-bottom: 0.02rem solid #FC0324;*/
          }
        }
      }
    }
    .list {
      >ul {
        margin-bottom: 0.11rem;
        >li {
          background: #fff;
          margin: 0.11rem 0.11rem 0;
          padding: 0.15rem 0.15rem 0.2rem;
          >p {
            border-bottom: 1px solid #EFEFEF;
            padding-bottom: 0.1rem;
            span {
              display: block;
              b {
                display: block;
                font-weight: 400;
                color: #444444;
                font-size:0.12rem;
                float: left;
                &:last-of-type {
                  margin-left: 0.04rem;
                  line-height: 0.19rem;
                  float: left;
                  img {
                    width: 0.19rem;
                    height: 0.19rem;
                    float: right;
                  }
                }
              }
            }
            >b {
              display: flex;
              display: -webkit-flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -o-flex;
              align-items: center;
              -webkit-align-items: center;
              -moz-align-items: center;
              -ms-align-items: center;
              -o-align-items: center;
              i {
                display: inline-block;
                font-style: normal;
                color: #292929;
                font-size: 0.12rem;
                line-height: 0.16rem;
                float: left;
                font-weight:400;
              }
              b{
                display: inline-block;
                border-left: 1px solid #D8D8D8;
                margin-left: 0.06rem;
                padding-left: 0.07rem;
                img {
                  width:0.12rem;
                  height:0.12rem;
                }
              }
            }
          }
          .product {
            margin-top: 0.16rem;
            position: relative;
            .productBox {
              display: flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -webkit-flex;
              display: -o-flex;
              .img {
                position: relative;
                img {
                  &:first-of-type {
                    width: 100%;
                    height: 100%;
                  }
                  &.zeng {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 0.23rem;
                    height: 0.23rem;
                  }
                }
                width: 0.8rem;
                height: 0.8rem;
              }
              .proContent {
                margin-left: 0.07rem;
                margin-top: 0.08rem;
                flex: 1;
                -webkit-flex: 1;
                -moz-flex: 1;
                -ms-flex: 1;
                -o-flex: 1;
                >b {
                  font-size:0.13rem;
                  font-weight:400;
                  color:rgba(41,41,41,1);
                  line-height:0.18rem;
                  display: block;
                  margin-bottom: 0.05rem;
                }
                >p{
                  align-items: flex-start;
                  -moz-align-items: flex-start;
                  -ms-align-items: flex-start;
                  -webkit-align-items: flex-start;
                  -o-align-items: flex-start;
                  >b {
                    font-size:0.11rem;
                    font-weight:400;
                    color:rgba(108,108,108,1);
                    line-height:0.16rem;
                    display: block;
                  }
                }
              }
            }
            .totalPrice {
              position: absolute;
              right: -0.02rem;
              z-index: 10;
              opacity:0.85;
              height: 0.8rem;
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              /*flex-direction: column;*/
              /*-webkit-flex-direction: column;*/
              /*-o-flex-direction: column;*/
              /*-ms-flex-direction: column;*/
              /*-moz-flex-direction: column;*/
              justify-content: flex-end;
              -webkit-justify-content: flex-end;
              -o-justify-content: flex-end;
              -ms-justify-content: flex-end;
              -moz-justify-content: flex-end;
              align-items: flex-end;
              -o-align-items: flex-end;
              -moz-align-items: flex-end;
              -ms-align-items: flex-end;
              -webkit-align-items: flex-end;
              &.totalPriceShadow {
                background:rgba(255,255,255,1);
                box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
                -webkit-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
                -moz-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
                -ms-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
                -o-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              }
              &+.totalPriceNoShadow {
                background:rgba(255,255,255,1);
              }
              .price {
                display: flex;
                display: -webkit-flex;
                display: -o-flex;
                display: -ms-flex;
                display: -moz-flex;
                align-items: flex-end;
                -webkit-align-items: flex-end;
                -o-align-items: flex-end;
                -ms-align-items: flex-end;
                -moz-align-items: flex-end;
                font-size: 0.14rem;
                font-weight:600;
                color:#222222;
                line-height:0.11rem;
                &:before {
                  content: '￥';
                  font-size:0.10rem;
                  font-weight:600;
                  line-height: 0.11rem;
                }
                i {
                  font-size: 0.11rem;
                  font-style: normal;
                  line-height: 0.11rem;
                }
              }
              >b {
                color: #908D8D;
                font-size: 0.11rem;
                line-height: 0.16rem;
                display: block;
                font-weight:400;
                text-align: center;
                white-space: nowrap;
              }
            }
            .bestSellingSwiper {
              /*padding-right: 0.6rem;*/
              width: 100%;
              .swiper-container {
                padding-right: 0.6rem;
                .swiper-wrapper {
                  >.swiper-slide {
                    width: 0.8rem;
                    position: relative;
                    background-color: white;
                    .img {
                      width: 0.8rem;
                      height: 0.8rem;
                      position: relative;
                      .tag{
                        position: absolute;
                        right: 0;
                        top:0;
                        font-size: .12rem;
                        .van-tag{
                          border-radius:0px 0px 0px 2px;
                        }
                      }
                      img {
                        &:first-of-type {
                          width: 100%;
                          height: 100%;
                        }
                        &.zeng {
                          position: absolute;
                          right: 0;
                          top: 0;
                          width: 0.23rem;
                          height: 0.23rem;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          .proFooter {
            margin-top: 0.1rem;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: space-between;
            >.p {
              font-size:0.12rem;
              font-weight:400;
              color:#FC0324;
              display: block;
              transform: scale(0.85,0.85);
              margin-left: -0.095rem;
            }
            .proBtn {
              display: flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -webkit-flex;
              display: -o-flex;
              float: right;
              .grayBtn {
                min-width:0.7rem;
                height: 0.27rem;
                margin-left: 0.1rem;
                border-radius:0.14rem;
                border:1px solid rgba(96,96,96,1);
                font-size:0.12rem;
                font-weight:400;
                color:rgba(38,38,38,1);
                padding: 0.05rem 0.11rem;
                background: none;
                outline: none;
                display: flex;
                display: -ms-flex;
                display: -webkit-flex;
                display: -moz-flex;
                display: -o-flex;
                justify-content: center;
                -webkit-justify-content: center;
                -ms-justify-content: center;
                -o--justify-content: center;
                -moz--justify-content: center;
                align-items: center;
                -webkit-align-items: center;
                -o-align-items: center;
                -moz-align-items: center;
                -ms-align-items: center;
              }
              .redBtn {
                min-width:0.7rem;
                height: 0.27rem;
                margin-left: 0.1rem;
                border-radius:0.14rem;
                border:1px solid #FC0324;
                font-size:0.12rem;
                font-weight:400;
                color:#FC0324;
                padding: 0.05rem 0.11rem;
                background: none;
                outline: none;
                display: flex;
                display: -ms-flex;
                display: -webkit-flex;
                display: -moz-flex;
                display: -o-flex;
                justify-content: center;
                -webkit-justify-content: center;
                -ms-justify-content: center;
                -o--justify-content: center;
                -moz--justify-content: center;
                align-items: center;
                -webkit-align-items: center;
                -o-align-items: center;
                -moz-align-items: center;
                -ms-align-items: center;
              }
            }
          }
        }
      }
    }
    .homeBtn {
      z-index: 10;
      position: fixed;
      right:0.17rem;
      bottom:0.8rem;
      width:0.4rem;
      height:0.4rem;
      border-radius: 50%;
      background:rgba(255,255,255,1);
      box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -webkit-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -moz-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -ms-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -o-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -o-flex;
      flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -webkit-flex-direction: column;
      -o-flex-direction: column;
      justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -webkit-justify-content: center;
      -o-justify-content: center;
      align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
        display: block;
      }
    }
    .empty {
      background: #fff;
      padding: 0 0 0.3rem;
      /*margin-top: 0.5rem;*/
      /*margin-bottom: 0.1rem;*/
      position: relative;
      z-index: 99;
      &.emptyNoProduct {
        flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -o-flex: 1;
        -ms-flex: 1;
      }
      img {
        width:0.88rem;
        height:0.88rem;
        margin: 0 auto 0.15rem;
      }
      p {
        font-size:0.13rem;
        font-weight:400;
        color:rgba(41,41,41,1);
        line-height:0.18rem;
        text-align: center;
      }
    }
  }
</style>
<style lang="scss">
  .donateList {
    display: flex;
    display: -webkit-flex;
    display:-o-flex;
    display:-moz-flex;
    display:-ms-flex;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -moz-flex-direction: column;
    flex-direction: column;
    -ms-flex-direction: column;
    .scroller {
      padding-top: 0;
    }
    .van-count-down {
      font-size: 0.1rem;
      font-weight: 400;
      color: #fc0324;
      line-height: 0.14rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/donateList.vue